/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react';
import styled from '@emotion/styled';
import { useStaticQuery, graphql } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import AnimatedSection from '../../../components/AnimatedSection';
import CommonSection from "../../../components/CommonSection";
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { RecipeNav } from "../../../components/RecipeList"

const EorzeaCafeIntroductionSection = ({list}) => {
  const { t } = useLocalization();
  const data = useStaticQuery(graphql`
    query EorzeaCafeIntroduction {
      icon_eorzeaCafe : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/EorzeacafeAtHome/icon_EorzeaCafe.png"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
    }
  `);


  return (
    <React.Fragment>
      <AnimatedSection>
      <RecipeNav list={list}/>
        <CommonSection css={css`
          > div{
            padding-bottom:0;
          }
          @media only screen and (max-width: ${breakpoint.smMax}){
            > div{
              padding-bottom:0;
            }
          }
        `}>
          
          <IntroWrapper>
            <ImageFrame>
              <GatsbyImage image={getImage(data.icon_eorzeaCafe)} alt={t('eorzeacafe_at_home.eorzeacafe.about.title')}/>
            </ImageFrame>
            <TextWrapper>
              <div className="title">{t('eorzeacafe_at_home.eorzeacafe.about.title')}</div>
              <div className="desc">{t('eorzeacafe_at_home.eorzeacafe.about.description')}</div>
            </TextWrapper>
          </IntroWrapper>
        </CommonSection>
      </AnimatedSection>
    </React.Fragment>
  );
}
 
export default EorzeaCafeIntroductionSection;


const IntroWrapper = styled.div`
  max-width:928px;
  margin:0 auto;
  display:flex;
  justify-content: space-between;
  align-items:center;

  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:block;
    text-align:center;
  }
`

const ImageFrame = styled.div`
  width:240px;
  padding:16px;
  background: #FFFFFF;
  border-radius: 6px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:160px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:0 auto 16px;
  }
`

const TextWrapper = styled.div`
  width: calc(100% - 272px);

  .title{
    font-weight: 900;
    font-size: 32px;
    line-height: 44px;
    letter-spacing: 0.03em;
    margin-bottom:32px;
    color: #2C2C2E;
  }

  .desc{
    font-size: 20px;
    line-height: 32px;
    color: #444448;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width: calc(100% - 192px);

    .title{
      font-size: 24px;
      line-height: 32px;
      margin-bottom:16px;
    }
    .desc{
      font-size: 16px;
      line-height: 28px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;
    .title{
      font-size: 18px;
      line-height: 28px;
    }
    .desc{
      font-size: 12px;
      line-height: 20px;
    }
  }
`
